export const EVENT_TYPE_LABELS = {
  feast_festival: "திருவிழா",
  prayer_meeting: "ஜெபக் கூட்டம்",
  retreat: "தியானம்",
  sacraments: "திருச்சடங்குகள்",
  social_service: "சமூக சேவை",
  youth_event: "இளைஞர் நிகழ்வு",
  marriage_class: "திருமண முன்பயிற்சி வகுப்பு",
  mass: "திருப்பலி",
  others: "மற்றவை"
};

export const getEventTypeTamil = (eventTypeName, otherValue = null) => {
  if (!eventTypeName && otherValue) {
    return otherValue;
  }

  return EVENT_TYPE_LABELS[eventTypeName] || eventTypeName || "-";
};


// Convert API options → Tamil dropdown
export const mapEventTypeOptions = (options = []) => {
  const mapped = options.map(item => {
    const key = item.label?.toLowerCase().replace(/\s+/g, "_");

    return {
      value: item.value,
      label: EVENT_TYPE_LABELS[key] || item.label
    };
  });

  mapped.push({
    value: "others",
    label: EVENT_TYPE_LABELS["others"]
  });

  return mapped;
};